import axios, { AxiosHeaders } from 'axios'
import Bugsnag from '@bugsnag/js'
import constants from '../config/constants'
import { i18n } from 'next-i18next'

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASEURL,
  withCredentials: true,
})

const getProxyBaseUrl = () => {
  const proxyBaseUrl =
    process.env.PROXY_API_BASEURL ?? process.env.NEXT_PUBLIC_PROXY_API_BASEURL

  if (!proxyBaseUrl) {
    return null
  }

  return proxyBaseUrl
}

instance.interceptors.request.use(
  (config) => {
    const headers = AxiosHeaders.from(config.headers)
    headers.set('Accept-Language', i18n?.language)

    const isSSR = typeof window === 'undefined'
    const proxyBaseUrl = isSSR ? getProxyBaseUrl() : null
    if (proxyBaseUrl) {
      config.baseURL = proxyBaseUrl
      headers.set('x-ssr-call', '1')

      if (process.env.PROXY_AUTH_TOKEN) {
        headers.set(
          'Proxy-Authorization',
          `Bearer ${process.env.PROXY_AUTH_TOKEN}`,
        )
      }
    }

    config.headers = headers

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  (response) => {
    // Modify the response here
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      if (typeof window !== 'undefined') {
        localStorage.removeItem(constants.IS_LOGGED_IN)
        localStorage.removeItem(constants.AUTH_TOKEN)
      }
    }
    if (error.response?.status?.toString().charAt(0) === '5') {
      Bugsnag.notify(error)
    }
    return Promise.reject(error)
  },
)

export default instance
